<template>
  <div style="width: 100%;height:100%;display: flex;align-items: center;">
    <div v-for="(item,index) in cptData.options" :key="index" class="nav" @click="changeNav(item,index)"
         :style="{backgroundColor: currIndex === index ? option.attribute.bgColorActive:option.attribute.bgColor,margin: '0 '+ option.attribute.space+'px'}"/>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-navigator",
  props: {
    option: Object,
    components: Array, current: Object
  },
  computed: {
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  watch: {
    'option.attribute.autoSwitch': {
      handler(newVal) {
        clearInterval(this.timer)
        this.timer = null
        if(newVal === true){
          this.autoSwitch();
        }
      }
    },
    'option.attribute.interval':{
      handler() {
        clearInterval(this.timer)
        this.timer = null
        this.autoSwitch();
      },
    },
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  data(){
    return {
      timer:null,
      currIndex:0,
      uuid:null,
      cptData:{},
      newData:"",
      jsFunFlag:false,
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    changeNav(item,index){
      this.currIndex = index
      this.$emit("clickHandler",this.option.interaction,item.value,item.value,'cpt-navigator',item.value)
    },
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras) {
            const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
           that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          that.processData(cptDataForm,that.newData,that.jsFunFlag)
          // this.cptData = res;
          // if(this.option.attribute.autoSwitch === true){
          //   this.autoSwitch();
          // }

        })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
    // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
          if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

      console.log(res,'res')
      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
      //判断此控件在九宫格里面就不请求数据
        if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
          const dataKey = this.option.attribute.cptTableData;
        // 创建一个新的数组用于存储结果
          let newres = [];
          // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
          res.forEach(item => {
            let newItem = {};
            dataKey.forEach(mapping => {
              newItem[mapping.namekey] = item[mapping.value];
            });
            // 合并原有的键值对
            Object.assign(newItem, item);
            newres.push(newItem);
          });

          let newObject = {
            options: newres
          };
          this.cptData = newObject;
              console.log(newObject,'newObject')
        }
        } else { // 如果配置了转换脚本
          this.cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
      this.cptData = res;
    } 
        if(this.option.attribute.autoSwitch === true){
      this.autoSwitch();
    }
},
    autoSwitch(){
      const that = this;
      let index = this.currIndex + 1
      this.timer = setInterval(()=>{
        if(index === that.cptData.options.length){
          index = 0;
        }
        this.changeNav(that.cptData.options[index], index)
        index++
      }, this.option.attribute.interval*1000)
    },
  },
  beforeUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped>
.nav{flex: 1;height: 20%;cursor: pointer;border-radius: 2px}
</style>
